module.exports = __webpack_public_path__ + "img/retailIFour.3b7cf87e.png";